module.exports = __webpack_public_path__ + "img/destaque2.b0e2cfd7.png";